import React, { useEffect, useState } from "react";
import * as api from "./../../api/api";
import LeftSponsers from "./../leftSponsers/leftSponsers";
import * as c from "./../../const";
import { Link } from "react-router-dom";
import Banner from "./../banner/banner";
import NoResult from "./../../assets/images/no-result.jpg";

//PAGINATION
import Pagination from "@material-ui/lab/Pagination";

//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
}));

export default function Results(props) {
  const classes = useStyles();
  const [loader, setLoader] = useState(true);
  const [results, setResults] = useState(false);
  const requestObj = props.history.location.state.data;
  const [data, setData] = useState("");
  const [banner, setBanner] = useState("");
  const [N, setN] = useState(1);

  const from = Number((N - 1) * 10 - 1);
  const till = Number(N * 10 - 1);

  useEffect(() => {
    const resultApi = async () => {
      try {
        const response = await api.searchPost(requestObj);
        console.log("response", response);
        let res = await api.banner(2);
        if (res) {
          setBanner(res.image);
        }
        if (response.length === 0) {
          setResults(true);
        }
        setData(response);
        setLoader(false);
      } catch (e) {}
    };
    window.scrollTo(0, 0);
    resultApi();
  }, []);

  const length = Math.ceil(data.length / 10);

  return (
    <div>
      <Banner img={banner} />
      <section className="sponsor py-5">
        <div className="container">
          <div className="row justify-content-lg-between justify-content-center">
            <div className="col-lg-3 col-md-6">
              <div className="left-sponsor">
                <LeftSponsers />
              </div>
            </div>

            {results ? (
              <div className="col-lg-9 col-md-12">
                <img src={NoResult} alt="no-result" />
              </div>
            ) : (
              <div className="col-lg-9 col-md-12">
                Search Results
                <div className="mid-sponsor">
                  <div className="card single-blog mb-3">
                    <div className="row no-gutters">
                      {Object.keys(data).map((index) => {
                        const url = c.URL;
                        let src = `${url}/${data[index].image[0]}`;
                        let blogId = data[index].id;
                        if (index > from && index <= till) {
                          return (
                            <>
                              <div className="col-md-3 py-3" key={index}>
                                {/* <a> */}
                                <img
                                  src={src}
                                  alt="blogImage"
                                  className="img-fluid"
                                  style={{ width: "170px", height: "170px" }}
                                />
                                {/* </a> */}
                              </div>
                              <div className="col-md-9">
                                <div className="card-body">
                                  <h5 className="card-title">
                                    {data[index].title}
                                  </h5>
                                  <p
                                    className="card-text"
                                    dangerouslySetInnerHTML={{
                                      __html: data[index].details.substring(
                                        0,
                                        250
                                      ),
                                    }}
                                  ></p>
                                  <Link
                                    exact
                                    to={"/blog/" + blogId}
                                    params={{ testvalue: "hello" }}
                                  >
                                    Continue Reading
                                  </Link>
                                  <i className="fas fa-long-arrow-alt-right"></i>
                                </div>
                              </div>
                            </>
                          );
                        }
                        return true;
                      })}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <Pagination
            className="float-right p-2 m-b-4"
            variant="outlined"
            hideNextButton={true}
            hidePrevButton={true}
            count={length}
            // count={10}
            color="primary"
            onClick={(e) => {
              setN(e.target.outerText);
            }}
          />
        </div>
      </section>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress />
      </Backdrop>
    </div>
  );
}
